import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IDocumentRes,
  IDropdownResponse,
  ICreateDocumentTemplate,
  IPostContentLibrary,
  IDocumentStatus
} from '../models';
import { AxiosResponse } from 'axios';
import { objectToQueryString } from '../helpers';

export const getDocuments = async (filters?: {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
  personId?: number | string;
  partnerId?: number | string;
  partnerSageId?: number | string;
  vendorTypeId?: number | string;
  subcontractorTypeId?: number | string;
  templateIds?: string[];
  statuses?: IDocumentStatus[];
  search?: string;
  startSentAt?: string;
  endSentAt?: string;
}): Promise<IDocumentRes> => {
  const queryString = objectToQueryString(filters);
  try {
    const { data } = await axios.get(`/api/documents?${queryString}`);
    return data;
  } catch (error) {
    logError(error, 'getDocuments failed');
    return Promise.reject(error);
  }
};

export const createDocumentTemplate = async (post: {
  personId: number | string;
  vendorId: string | number;
  templateIds: string[];
  contentLibraries: IPostContentLibrary[];
}): Promise<ICreateDocumentTemplate[]> => {
  try {
    const { data } = await axios.post(`/api/documents/templates`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createDocumentTemplate failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const getDocumentStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/documents/statuses`);
    return data;
  } catch (error) {
    logError(error, 'getDocumentStatuses failed');
    return Promise.reject(error);
  }
};

export const exportDocumentsCSV = async (post: {
  sort?: string;
  sortDirection?: string;
  personId?: number | string;
  partnerId?: number | string;
  partnerSageId?: number | string;
  vendorTypeId?: number | string;
  subcontractorTypeId?: number | string;
  templateIds?: string[];
  statuses?: IDocumentStatus[];
  search?: string;
  startSentAt?: string;
  endSentAt?: string;
}): Promise<AxiosResponse<string>> => {
  const queryString = objectToQueryString(post);
  try {
    const res = await axios.post(`/api/documents/export-csv?${queryString}`);
    return res;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'exportDocumentsCSV failed'
    );
    return Promise.reject(error.response.data);
  }
};
